var _readOnlyError = require("/opt/build/repo/node_modules/@babel/runtime/helpers/readOnlyError.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});

/** A simple Least Recently Used map */
var LRUMap = /*#__PURE__*/function () {
  "use strict";

  function LRUMap(_maxSize) {
    _classCallCheck(this, LRUMap);
    this._maxSize = _maxSize;
    this._cache = new Map();
  }

  /** Get the current size of the cache */
  return _createClass(LRUMap, [{
    key: "size",
    get: function get() {
      return this._cache.size;
    }

    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */
  }, {
    key: "get",
    value: function get(key) {
      var value = this._cache.get(key);
      if (value === undefined) {
        return undefined;
      }
      // Remove and re-insert to update the order
      this._cache.delete(key);
      this._cache.set(key, value);
      return value;
    }

    /** Insert an entry and evict an older entry if we've reached maxSize */
  }, {
    key: "set",
    value: function set(key, value) {
      if (this._cache.size >= this._maxSize) {
        // keys() returns an iterator in insertion order so keys().next() gives us the oldest key
        this._cache.delete(this._cache.keys().next().value);
      }
      this._cache.set(key, value);
    }

    /** Remove an entry and return the entry if it was in the cache */
  }, {
    key: "remove",
    value: function remove(key) {
      var value = this._cache.get(key);
      if (value) {
        this._cache.delete(key);
      }
      return value;
    }

    /** Clear all entries */
  }, {
    key: "clear",
    value: function clear() {
      this._cache.clear();
    }

    /** Get all the keys */
  }, {
    key: "keys",
    value: function keys() {
      return Array.from(this._cache.keys());
    }

    /** Get all the values */
  }, {
    key: "values",
    value: function values() {
      var values = [];
      this._cache.forEach(function (value) {
        return values.push(value);
      });
      return values;
    }
  }]);
}();
exports.LRUMap = LRUMap;